import {ViewRegistry} from "@lernetz/ts-lib"
import {Route} from "@lernetz/ui-components/src/router/Route";
import {UiModule} from "../core/interface";
import {AuthorCardView} from "../pages/good-practice/details/author-info.component";
import {gateway} from "../services/gateway";
import {trackEvent} from "../services/tracker";
import {Infobox, InfoboxView} from "./components/article/infobox.component";
import {Quote, QuoteView} from "./components/article/quote.component"

const views = new ViewRegistry()
views.add(Quote, () => new QuoteView());
views.add(Infobox, () => new InfoboxView());
views.add("AuthorCard", () => new AuthorCardView());

const GoodPracticeModule: UiModule = {
    views,
    routes: [
        new Route({
            name: "good-practice-details",
            pattern: "/:lang/good-practice/:id",
            content: (params, route) => {
                let data = {} as any;
                gateway.goodPracticeGateway.get(params.id).then( goodPractice => {
                    data.goodPractice = {
                        ...goodPractice,
                        headerAuthors: goodPractice.authors.filter( (author: any) => !author.hideInHeader)
                    };
                    trackEvent('good-practice-details', { goodPractice: goodPractice.title})
                });
                return {
                    view: "GoodPracticeDetailsPage",
                    data,
                };
            },
        }),
        new Route({
            name: "good-practice",
            pattern: "/:lang/good-practice",
            content: (params, route) => {
                let data = {} as any;
                gateway.goodPracticeGateway.find().then( goodPractices => {
                    data.goodPractices = goodPractices
                });
                return {
                    view: "GoodPracticePage",
                    data,
                };
            },
        }),
    ]
}

export default GoodPracticeModule
